export const postData = async (url, body) => {
    let response;
    try {
        response = await fetch(url, {
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'POST',
        });
    }
    catch (e) {
        return Promise.reject(e);
    }
    if (!response.ok) {
        return Promise.reject(new Error('Failed to send GT-12 tracking data to server'));
    }
    return Promise.resolve();
};
